import { motion } from 'framer-motion';
import { Info, Lightbulb, TriangleAlert } from 'lucide-react';
import Inline from './Inline';
import CodeBlock from './CodeBlock';
import Ladder from './Ladder';
import Icon from './Icon';

const CALLOUT = {
  tip: { icon: Lightbulb, label: 'Tip' },
  info: { icon: Info, label: 'Good to know' },
  warn: { icon: TriangleAlert, label: 'Watch out' },
};

function Block({ b }) {
  switch (b.type) {
    case 'p':
      return <p><Inline text={b.text} /></p>;
    case 'h':
      return <h2 className="lesson-h">{b.text}</h2>;
    case 'ul':
      return <ul className="bullets">{b.items.map((t, i) => <li key={i}><Inline text={t} /></li>)}</ul>;
    case 'ol':
      return <ol className="numbered">{b.items.map((t, i) => <li key={i}><Inline text={t} /></li>)}</ol>;
    case 'code':
      return <CodeBlock lang={b.lang} text={b.text} title={b.title} />;
    case 'callout': {
      const c = CALLOUT[b.kind];
      const I = c.icon;
      return (
        <aside className={`callout callout-${b.kind}`}>
          <span className="callout-icon"><I size={20} /></span>
          <div>
            <strong className="callout-title">{b.title || c.label}</strong>
            <p><Inline text={b.text} /></p>
          </div>
        </aside>
      );
    }
    case 'table':
      return (
        <div className="table-wrap">
          <table>
            <thead><tr>{b.head.map((c, i) => <th key={i}><Inline text={c} /></th>)}</tr></thead>
            <tbody>
              {b.rows.map((r, i) => (
                <tr key={i}>{r.map((c, j) => <td key={j}><Inline text={c} /></td>)}</tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    case 'cards':
      return (
        <div className="concepts">
          {b.items.map((c, i) => (
            <motion.div
              className="concept"
              key={i}
              whileHover={{ y: -4 }}
              transition={{ type: 'spring', stiffness: 300, damping: 20 }}
            >
              <span className="concept-icon"><Icon name={c.icon} size={20} /></span>
              <strong>{c.title}</strong>
              <p><Inline text={c.text} /></p>
            </motion.div>
          ))}
        </div>
      );
    case 'steps':
      return (
        <ol className="timeline">
          {b.items.map((s, i) => (
            <li key={i}>
              <span className="timeline-dot">{i + 1}</span>
              <div>
                <strong><Inline text={s.title} /></strong>
                <p><Inline text={s.text} /></p>
              </div>
            </li>
          ))}
        </ol>
      );
    case 'ladder':
      return <Ladder title={b.title} actors={b.actors} msgs={b.msgs} />;
    default:
      return null;
  }
}

export default function Blocks({ blocks }) {
  return blocks.map((b, i) => <Block key={i} b={b} />);
}
